/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {LegalEntityCompanyDTO} from './LegalEntityCompanyDTO';
import {LegalEntityParentCompanyDTO} from './LegalEntityParentCompanyDTO';

/**
 * The LegalEntitySubsidiaryDTO model module.
 * @module model/LegalEntitySubsidiaryDTO
 * @version v0
 */
export class LegalEntitySubsidiaryDTO {
  /**
   * Constructs a new <code>LegalEntitySubsidiaryDTO</code>.
   * @alias module:model/LegalEntitySubsidiaryDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>LegalEntitySubsidiaryDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/LegalEntitySubsidiaryDTO} obj Optional instance to populate.
   * @return {module:model/LegalEntitySubsidiaryDTO} The populated <code>LegalEntitySubsidiaryDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new LegalEntitySubsidiaryDTO();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'Number');
      if (data.hasOwnProperty('legalEntityCompanies'))
        obj.legalEntityCompanies = ApiClient.convertToType(data['legalEntityCompanies'], [LegalEntityCompanyDTO]);
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('authorityCode'))
        obj.authorityCode = ApiClient.convertToType(data['authorityCode'], 'String');
      if (data.hasOwnProperty('active'))
        obj.active = ApiClient.convertToType(data['active'], 'Boolean');
      if (data.hasOwnProperty('deletable'))
        obj.deletable = ApiClient.convertToType(data['deletable'], 'Boolean');
      if (data.hasOwnProperty('legalEntityParentCompany'))
        obj.legalEntityParentCompany = LegalEntityParentCompanyDTO.constructFromObject(data['legalEntityParentCompany']);
    }
    return obj;
  }
}

/**
 * @member {Number} id
 */
LegalEntitySubsidiaryDTO.prototype.id = undefined;

/**
 * @member {Array.<module:model/LegalEntityCompanyDTO>} legalEntityCompanies
 */
LegalEntitySubsidiaryDTO.prototype.legalEntityCompanies = undefined;

/**
 * @member {String} name
 */
LegalEntitySubsidiaryDTO.prototype.name = undefined;

/**
 * @member {String} authorityCode
 */
LegalEntitySubsidiaryDTO.prototype.authorityCode = undefined;

/**
 * @member {Boolean} active
 */
LegalEntitySubsidiaryDTO.prototype.active = undefined;

/**
 * @member {Boolean} deletable
 */
LegalEntitySubsidiaryDTO.prototype.deletable = undefined;

/**
 * @member {module:model/LegalEntityParentCompanyDTO} legalEntityParentCompany
 */
LegalEntitySubsidiaryDTO.prototype.legalEntityParentCompany = undefined;

